/*
 * NANOVIT — Calculadora de frete no carrinho.
 * Portado do <shipping-estimator> da Horizon (versão nova), des-minificado e
 * sem dependências (motion lib / themeVariables). Usa as rotas nativas do
 * Shopify: cart/prepare_shipping_rates.json + cart/async_shipping_rates.json.
 */
(function () {
  if (!customElements.get('nv-country-selector')) {
    customElements.define('nv-country-selector', class extends HTMLElement {
      constructor() {
        super();
        this._onCountryChanged = this._onCountryChanged.bind(this);
      }
      connectedCallback() {
        this.countryElement = this.querySelector('[name="address[country]"]');
        this.provinceElement = this.querySelector('[name="address[province]"]');
        if (!this.countryElement || !this.provinceElement) return;
        this.countryElement.addEventListener('change', this._onCountryChanged);
        this._onCountryChanged();
      }
      disconnectedCallback() {
        if (this.countryElement) this.countryElement.removeEventListener('change', this._onCountryChanged);
      }
      _onCountryChanged() {
        const option = this.countryElement.options[this.countryElement.selectedIndex];
        const provinces = JSON.parse(option.getAttribute('data-provinces') || '[]');
        this.provinceElement.parentElement.hidden = provinces.length === 0;
        if (provinces.length) {
          this.provinceElement.innerHTML = '';
          provinces.forEach(function (data) {
            this.provinceElement.options.add(new Option(data[1], data[0]));
          }, this);
        }
      }
    });
  }

  if (!customElements.get('nv-shipping-estimator')) {
    customElements.define('nv-shipping-estimator', class extends HTMLElement {
      constructor() {
        super();
        this._estimate = this._estimate.bind(this);
      }
      connectedCallback() {
        this.button = this.querySelector('[type="submit"]');
        this.results = this.querySelector('.nv-ship__results');
        if (this.button) this.button.addEventListener('click', this._estimate);
      }
      disconnectedCallback() {
        if (this.button) this.button.removeEventListener('click', this._estimate);
      }
      async _estimate(event) {
        event.preventDefault();
        const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        const zipEl = this.querySelector('[name="address[zip]"]');
        const countryEl = this.querySelector('[name="address[country]"]');
        const provinceEl = this.querySelector('[name="address[province]"]');
        const zip = zipEl ? zipEl.value : '';
        const country = countryEl ? countryEl.value : '';
        const province = provinceEl ? provinceEl.value : '';
        if (!zip) { this._render('<p>Informe o CEP para calcular o frete.</p>'); this.results.hidden = false; return; }
        const q = 'shipping_address[zip]=' + encodeURIComponent(zip) +
                  '&shipping_address[country]=' + encodeURIComponent(country) +
                  '&shipping_address[province]=' + encodeURIComponent(province);
        this.button.setAttribute('aria-busy', 'true');
        this.button.disabled = true;
        try {
          const prepare = await fetch(root + 'cart/prepare_shipping_rates.json?' + q, { method: 'POST' });
          if (prepare.ok) {
            const rates = await this._getRates(root, q);
            this._renderRates(rates);
          } else {
            this._renderError(await prepare.json());
          }
        } catch (e) {
          this._render('<p>Não foi possível calcular o frete agora. Tente novamente.</p>');
        }
        this.results.hidden = false;
        this.button.removeAttribute('aria-busy');
        this.button.disabled = false;
      }
      async _getRates(root, q) {
        const text = await (await fetch(root + 'cart/async_shipping_rates.json?' + q)).text();
        return text === 'null' ? this._getRates(root, q) : JSON.parse(text).shipping_rates;
      }
      _renderRates(rates) {
        if (!rates || !rates.length) {
          this._render('<p>Nenhuma opção de frete encontrada para este CEP.</p>');
          return;
        }
        const items = rates.map(function (r) {
          return '<li><span>' + r.presentment_name + '</span><strong>' + this._money(r.price) + '</strong></li>';
        }, this).join('');
        this._render('<p class="nv-ship__results-title">Opções de entrega</p><ul class="nv-ship__list" role="list">' + items + '</ul>');
      }
      _renderError(errors) {
        const items = Object.keys(errors).map(function (k) {
          return '<li>' + errors[k] + '</li>';
        }).join('');
        this._render('<p class="nv-ship__results-title">Confira os dados informados</p><ul class="nv-ship__list" role="list">' + items + '</ul>');
      }
      _money(value) {
        // async_shipping_rates retorna o preço em unidade maior (ex.: "19.90")
        const n = parseFloat(value);
        if (isNaN(n)) return value;
        return 'R$ ' + n.toFixed(2).replace('.', ',');
      }
      _render(html) {
        this.results.innerHTML = html;
      }
    });
  }
})();
